import React from 'react';

import ApprovalItemSkeleton from './EFakturaItem/EFakturaItemSkeleton';

import './EFakturaList.scss';

const EFakturaApprovalListSkeleton: React.FC<{ count?: number; darkSkeleton?: boolean }> = ({
    count = 3,
    darkSkeleton = false,
}) => (
    <div className="eFaktura-list eFaktura-list--skeleton">
        <ul className="eFaktura-list__container" data-testid="efaktura-list-loading">
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <ApprovalItemSkeleton darkSkeleton={darkSkeleton} key={index} />
            ))}
        </ul>
    </div>
);

export default EFakturaApprovalListSkeleton;
